import React from "react"
import MsoSnippet from "./mso-snippet"
import { useSettings } from "../editor"

export default function Section({
  children,
  backgroundColor: backgroundColorSettingName,
  borderRadius: borderRadiusSettingName,
  width = "600",
  padding = "20px",
  style = ""
}) {
  const settings = useSettings()
  const colorSetting = settings.find(s => s.name === backgroundColorSettingName)
  const borderRadiusSetting = settings.find(
    s => s.name === borderRadiusSettingName
  )
  const backgroundColor = colorSetting?.value || "#aaaaaa"
  const borderRadius = borderRadiusSetting?.value || 12

  const msoContainer = `<center><table cellpadding="0" cellspacing="0" align="center" style="${style}" width="600" bgcolor="${backgroundColor}"><tr><td>`

  return (
    <>
      <MsoSnippet value={msoContainer} />
      <div
        style={{
          backgroundColor,
          borderRadius: parseInt(borderRadius),
          overflow: "hidden",
          maxWidth: width,
          margin: "0px auto"
        }}
      >
        <table
          bgcolor={backgroundColor}
          cellPadding="0"
          cellSpacing="0"
          width="100%"
          style={{ tableLayout: "fixed" }}
        >
          <tbody>
            <tr>
              <td style={{ padding }}>{children}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <MsoSnippet value="</td></tr></table></center>" />
    </>
  )
}
